import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="content-summary"
export default class extends Controller {
  static targets = [
    "finalDiagnosis",
    "otherDiagnoses",
    "clinicalExcellenceTopics",
    "basicSciencesTopics",
  ];

  connect() {}

  updateContent(event) {
    [
      ...this.finalDiagnosisTargets,
      ...this.otherDiagnosesTargets,
      ...this.clinicalExcellenceTopicsTargets,
      ...this.basicSciencesTopicsTargets,
    ].forEach((target) => {
      // Find all inner doc <li> elements
      const docListItems = target.querySelectorAll("[data-document-id]");
      docListItems.forEach((docItem) => {
        if (docItem.dataset.documentId === event.target.dataset.documentId) {
          docItem.remove();
        }
      });

      // After possible removal, check if any doc items remain
      const remainingDocs = target.querySelectorAll("[data-document-id]");
      if (remainingDocs.length === 0) {
        target.remove(); // Remove the entire title if no docs left
      }
    });

    const customEvent = new CustomEvent('content-summary:updateContent', { bubbles: true });
    this.element.dispatchEvent(customEvent);
  }
}
